import React, { useState } from 'react';
import { Copy, Check, Link2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const CopyReferralLinkButton = ({
  referralCode,
  baseUrl = window.location.origin,
  campaignSlug,
  teamPageSlug,
  variant = 'default', // 'default', 'compact', 'inline'
}) => {
  const [copied, setCopied] = useState(false);

  // Build the referral URL
  let url = baseUrl;
  if (teamPageSlug) {
    url = `${baseUrl}/fundraise/${teamPageSlug}?ref=${referralCode}`;
  } else if (campaignSlug) {
    url = `${baseUrl}/campaign/${campaignSlug}?ref=${referralCode}`;
  } else {
    url = `${baseUrl}/?ref=${referralCode}`;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  if (variant === 'inline') {
    return (
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={handleCopy}
        className="gap-2"
        data-testid="copy-referral-link-inline"
      >
        {copied ? (
          <>
            <Check className="w-4 h-4 text-emerald-500" />
            Copied!
          </>
        ) : (
          <>
            <Link2 className="w-4 h-4" />
            Copy Referral Link
          </>
        )}
      </Button>
    );
  }

  if (variant === 'compact') {
    return (
      <Button 
        variant="outline" 
        onClick={handleCopy}
        className="gap-2"
        data-testid="copy-referral-link-compact"
      >
        {copied ? (
          <>
            <Check className="w-4 h-4 text-emerald-500" />
            Copied!
          </>
        ) : (
          <>
            <Copy className="w-4 h-4" />
            Copy Link
          </>
        )}
      </Button>
    );
  }

  // Default variant with full URL display
  return (
    <div className="space-y-2" data-testid="copy-referral-link-default">
      <label className="block text-sm font-medium text-foreground">
        Your Referral Link
      </label>
      <div className="flex gap-2">
        <Input 
          value={url}
          readOnly
          className="flex-1 font-mono text-sm bg-secondary"
        />
        <Button 
          onClick={handleCopy}
          className={`min-w-[100px] ${
            copied 
              ? 'bg-emerald-500 hover:bg-emerald-600' 
              : 'bg-violet-500 hover:bg-violet-600'
          }`}
        >
          {copied ? (
            <>
              <Check className="w-4 h-4 mr-2" />
              Copied!
            </>
          ) : (
            <>
              <Copy className="w-4 h-4 mr-2" />
              Copy
            </>
          )}
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Share this link to earn rewards when people donate
      </p>
    </div>
  );
};

export default CopyReferralLinkButton;
